<template>
  <v-dialog
    :dialog="dialog"
    max-width="500px"
    transition="dialog-top-transition"
  >
    <v-card rounded="xl" :disabled="!canEdit">
      <v-card-title class="d-flex justify-space-between align-center" v-if="canEdit">
        <div class="text-medium-emphasis ps-2">
          {{ isEdit ? "Edit " : "Add New " }}
          {{ isEvent ? "Event" : "Calendar" }}
        </div>
        <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="overflow-y:auto;">
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Title"
            :variant="fieldVariant"
            v-model="name"
            :rules="RULES.REQUIRED_FIELD('Name')"
            :density="fieldDensity"
            :color="fieldColor"
          ></v-text-field>

          <v-textarea
            :variant="fieldVariant"
            label="Description"
            v-model="description"
            rows="1"
            auto-grow
            :density="fieldDensity"
            :color="fieldColor"
          ></v-textarea>

          <v-autocomplete
             v-if="isEdit && isEvent"
             label="Event Status"
             :items="eventStatus"
             :variant="fieldVariant"
             :density="fieldDensity"
             v-model="event_Status"
          ></v-autocomplete>

           <v-autocomplete
            v-if="isCalendar"
            v-model="calendarType"
            label="Type"
            :items="calendarTypes"
            :variant="fieldVariant"
            :density="fieldDensity"
            :color="fieldColor"
            :rules="RULES.REQUIRED_FIELD('Calendar Type')"
          ></v-autocomplete>
          
          <div v-if="isEvent" style="display: flex; display: inline; margin-top: 5%;">
            <v-row style="gap: 10px;">
              <v-text-field
                type="date"
                label="Date"
                :variant="fieldVariant"
                v-model="fromDate"
                :rules="RULES.REQUIRED_FIELD('Date')"
                style="width: 150px"
                :color="fieldColor"
              ></v-text-field>

              <v-text-field
                type="time"
                label="From"
                :variant="fieldVariant"
                v-model="fromTime"
                :rules="isAllDay ? [] : RULES.REQUIRED_FIELD('Time')"
                style="width: 100px"
                :color="fieldColor"
                :disabled="isAllDay"
              ></v-text-field>

              <v-text-field
                type="time"
                label="To"
                :variant="fieldVariant"
                v-model="toTime"
                :rules="isAllDay ? [] : RULES.REQUIRED_FIELD('Time')"
                style="width: 100px"
                :color="fieldColor"
                :disabled="isAllDay"
              ></v-text-field>
            </v-row>
          </div>

          <div>
            <!-- Selected Users & contacts-->
            <v-row>
              <DefaultDisplay
                :callEnabled="false"
                @selectItem="addParticipant"
                :searchOnly="true"
                :displayOnlyUser="isCalendar"
                :searchMasterList="getsearchMasterList"
              ></DefaultDisplay>
              <v-checkbox v-if="isEvent" label="All Day" color="primary" v-model="isAllDay"></v-checkbox>
            </v-row>

            

            <!-- Display selected Users -->
            <span
              v-if="selectedUsers.length || selectedContacts.length"
              style="font-size: small"
              class="text-medium-emphasis"
              >{{ isEvent ? "Event" : "Calendar"}} Participant(s)</span
            >
            <v-row>
              <div v-for="id in selectedUsers" :key="id" style="margin-top: 3%">
                <v-badge color="red" content="X" style="cursor: pointer;" @click="removeUserParticipant(id)">
                  <UserPopup :user_id="id" :tooltip="false" />
                </v-badge>
              </div>
            </v-row>

            <!-- Display Selected Contacts -->
            <v-row v-if="isEvent">
              <div v-for="id in selectedContacts" :key="id" style="margin-top: 3%">
                 <v-badge color="red" content="X" style="cursor: pointer;" @click="removeContactParticipant(id)">
                    <ContactPopup :contact_id="id" :tooltip="false" />
                  </v-badge>
              </div>
            </v-row>
          </div>

          <br />
          <!-- To view other info while calendar disabled -->
          <div v-if="!canEdit && isEvent && isEdit">
            <v-text-field
              v-if="location"
              label="Location"
              :variant="fieldVariant"
              :density="fieldDensity"
              v-model="location"
            ></v-text-field>

            <v-textarea
              v-if="notes"
              :variant="fieldVariant"
              label="Notes"
              v-model="notes"
              rows="1"
              auto-grow
              :density="fieldDensity"
              :color="fieldColor"
            ></v-textarea>
            <v-autocomplete
              label="Time Zone"
              v-model="timeZone"
              :items="timezones"
              :variant="fieldVariant"
              :density="fieldDensity"
              :color="fieldColor"
            ></v-autocomplete>
          </div>

          <v-row v-if="isCalendar">
            <input
              type="color"
              ref="colorInput"
              v-model="color"
              style="opacity: 0; width: 0; height: 0; position: absolute"
            />
            <span
              style="margin-top: 3%; font-size: small"
              class="text-medium-emphasis"
              >Color</span
            >
            <v-icon
              size="40"
              label="Color"
              :style="{ color: color }"
              @click="this.$refs.colorInput.click()"
              style="cursor: pointer; margin-top: 3%; margin-bottom: 2%"
            >
              mdi-calendar-month
            </v-icon>
          </v-row>
        </v-form>
      
      <!-- Other Event Info -->
      <v-expansion-panels  v-if="isEvent && canEdit" v-model="panel" @click="panel != panel">
        <v-expansion-panel title="Other Info">
           <v-expansion-panel-text>
               <v-text-field
                  label="Location"
                  :variant="fieldVariant"
                  :density="fieldDensity"
                  v-model="location"
                ></v-text-field>

                <v-textarea
                  :variant="fieldVariant"
                  label="Notes"
                  v-model="notes"
                  rows="1"
                  auto-grow
                  :density="fieldDensity"
                  :color="fieldColor"
                ></v-textarea>
                <v-autocomplete
                  label="Time Zone"
                  v-model="timeZone"
                  :items="timezones"
                  :variant="fieldVariant"
                  :density="fieldDensity"
                  :color="fieldColor"
                ></v-autocomplete>
            </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="canEdit">
        <v-btn color="red darken-1" text @click="closeDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="green"
          @click="handleSubmit"
          :disabled="!valid"
          variant="flat"
          rounded="xl"
          >{{ isEdit ? "Update" : "Add" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import { RULES } from "@/constants/validationRules.js";
import DefaultDisplay from "../CallBar/DefaultDisplay.vue";
import UserPopup from "../Avatar/UserPopup.vue";
import ContactPopup from "../Avatar/ContactPopup.vue";
import { mapGetters, mapActions } from "vuex";
import "vue-cal/style";
import { CALENDAR_TYPES, EVENT_STATUS, CALENDAR_ROLES } from "@/constants/constantsValues.js";
import dayjs from "dayjs"; // Import dayjs
export default {
  name: "CalendarForm",
  data() {
    return {
      name: "",
      description: "",
      fromDate: "",
      fromTime: "",
      toTime: "",
      participants: {},
      color: "#1976D2",
      calendarType: "",
      eventType: "Never",
      event_Status : "",
      location: "",
      timeZone: "",
      notes : "",
      isAllDay: false,
      valid: true,
      RULES,
      fieldVariant: "outlined",
      fieldDensity: "default",
      selectedContacts: [],
      selectedUsers: [],
      panel : true,
      eventId : null, // to update events
      canEdit : true, // owner only can edit event
      cal_Types : ["OD","DSS"] // temp variable for this v1 release
    };
  },
  watch: {
    isAllDay(newVal) {
      if (newVal) {
        this.fromTime = "00:00";
        this.toTime = "23:59";
      } else {
        this.fromTime = "";
        this.toTime = "";
      }
    },
    fromDate(newVal) {
      if (this.isAllDay) {
        this.fromTime = "00:00";
        this.toTime = "23:59";
      }
    }
  },
  components: {
    DefaultDisplay,
    UserPopup,
    ContactPopup,
  },
  props: {
    dialog: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    isCalendar: { type: Boolean, default: false },
    calendar: { type: Object, default: null },
    isEvent: { type: Boolean, default: false },
    event: { type: Object, default: null },
  },
  computed: {
    ...mapGetters("people", ["getsearchMasterList"]),
    ...mapGetters("calendar",["calendarList"]),
    ...mapGetters(["userId"]),
    timezones() {
      return Intl.supportedValuesOf("timeZone");
    },
    calendarTypes() {
      if (!this.calendarList || this.calendarList?.length === 0) {
        //return Object.values(CALENDAR_TYPES);
        return this.cal_Types;
      }
      return this.cal_Types.filter(type =>
        this.calendarList.every(calendar => calendar.type !== type)
      );
    },
    fieldColor() {
      return this.color || "#1976D2";
    },
    eventStatus(){
      return Object.values(EVENT_STATUS || {}).filter((status)=> status !== EVENT_STATUS.SCHEDULED);
    }
  },
  methods: {
    ...mapActions("calendar", ["createCalendar", "updateCalendar", "createEvent", "updateEvent", "addCalendarMember", "removeCalendarMember", "addEventMember", "removeEventMember"]),

    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      if (this.isCalendar) {
        if (this.isEdit) {
           let data = {
            name: this.name,
            description: this.description,
            color: this.color,
            calendarType: this.calendarType
          };
          await this.updateCalendar(data);
        } else {
          let data = {
            name: this.name,
            description: this.description,
            color: this.color,
            members: this.selectedUsers,
            calendarType: this.calendarType
          };
          await this.createCalendar(data);
        }
        this.closeDialog();
      } else if (this.isEvent) {
        let startTime, endTime;

        if (this.isAllDay) {
          // For all-day events, set start to beginning of day and end to end of day
          startTime = dayjs(this.fromDate).startOf('day').valueOf();
          endTime = dayjs(this.fromDate).endOf('day').valueOf();
        } else {
          // For timed events, combine date and time
          startTime = dayjs(`${this.fromDate} ${this.fromTime}`).valueOf();
          endTime = dayjs(`${this.fromDate} ${this.toTime}`).valueOf();
        }

        let  eventData = {
          title: this.name,
          description: this.description,
          location: this.location,
          start_time: startTime,
          end_time: endTime,
          all_day: this.isAllDay,
          timezone: this.timeZone,
          notes: this.notes,
          status: this.event_Status || EVENT_STATUS.SCHEDULED // Use selected status or default
        };

        if (this.isEdit) {
          await this.updateEvent({event_id: this.event.event_id, data : eventData});
        } else {
          let participants = [
              ...this.selectedUsers.map(id => ({ type: 'user', id })),
              ...this.selectedContacts.map(id => ({ type: 'contact', id }))
            ];
          eventData.participants = [...participants];
         
          await this.createEvent(eventData);
        }
        this.closeDialog();
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    addParticipant(item) {
      if (item.type === "contact") {
        if (!this.selectedContacts.includes(item.contact_id)) {
          if(this.isEdit && this.isEvent){
            const data = { participants : [{"id": item.contact_id, type: "contact"}], type : "add" };
            this.addEventMember({event_id : this.eventId, data : data});
          }
          this.selectedContacts.push(item.contact_id);
        }
      } else if (item.type === "user") {
        if (!this.selectedUsers.includes(item.user_id)) {
          if(this.isEdit){
            if(this.isCalendar){
              this.addCalendarMember({ member_id : item.user_id , role : CALENDAR_ROLES.VIEWER })
            }else if(this.isEvent){
              const data = { participants : [{"id": item.user_id, type: "user"}], type : "add" };
              this.addEventMember({event_id : this.eventId, data : data});
            }
          }
          this.selectedUsers.push(item.user_id);
        }
      }
    },
    removeUserParticipant(id){
      if(this.isEdit){
        if(this.isCalendar){
          this.removeCalendarMember({user_id: id});
        }else if(this.isEvent){
          const data = { participants : [{"id": id, type: "user"}], type : "remove" }
          this.removeEventMember({event_id : this.eventId, data : data})
        }
      }
      this.selectedUsers = this.selectedUsers.filter((user_id)=> user_id != id);
    },
    removeContactParticipant(id){
      if(this.isEdit && this.isEvent){
          const data = { participants : [{"id": id, type: "contact"}], type: "remove" }
          this.removeEventMember({event_id : this.eventId, data : data})
      }
      this.selectedContacts = this.selectedContacts.filter((contact_id)=> contact_id != id);
    },
    openColorPicker() {
      let colorInput = this.$refs.colorInput;
      colorInput.click();
    },
  },
  created() {
    if (this.isCalendar) {
      this.fieldDensity = "default";
      this.fieldVariant = "outlined";
      if(this.isEdit){
        this.name = this.calendar.name;
        this.description = this.calendar.description;
        this.color = this.calendar.color;
        this.calendar.calendar_members.forEach((member)=>{ if(member.role != CALENDAR_ROLES.OWNER){this.selectedUsers.push(member.user_id)} } );
        this.calendarType = this.calendar.type;
      }
    }
    if (this.isEvent) {
      this.fieldDensity = "compact";
      this.fieldVariant = "underlined";
      this.canEdit = true;
       
      //create event by dragging
      if (this.event && !this.isEdit) {
        this.fromDate = this.dayjs(this.event.event.start).format("YYYY-MM-DD");
        this.fromTime = this.dayjs(this.event.event.start).format("HH:mm");
        this.toTime = this.dayjs(this.event.event.end).format("HH:mm");
        if(this.userId != this.event.event.schedule){
          this.selectedUsers.push(this.event.event.schedule);
        }
        this.name = "Meeting"
      }
      //Edit and View Event
      if(this.isEdit){
        this.canEdit = this.event.deletable;
        this.panel = true;
        this.name = this.event.title;
        this.description = this.event.description;
        this.fromDate = this.dayjs(this.event.start).format("YYYY-MM-DD");
        this.fromTime = this.dayjs(this.event.start).format("HH:mm");
        this.toTime = this.dayjs(this.event.end).format("HH:mm");
        this.timeZone = this.event.timezone;
        this.event_Status = this.event.status;
        this.isAllDay = this.event.all_day;
        this.location = this.event.location;
        this.notes = this.event.notes;
        this.eventId = this.event.event_id;
        this.event.event_participants?.forEach(item => {
          if(item?.contact_id){
            this.selectedContacts.push(item.contact_id);
          }else if(item?.user_id && item?.user_id != this.event.author){
            this.selectedUsers.push(item.user_id);
          }
        });
      }
    }
  },
};
</script>
<style scoped></style>
